// extracted by mini-css-extract-plugin
module.exports = {"base":"TextBoxFilter_base__eq5x1"};